import { Field } from "formik";
import FieldLabel from "./FieldLabel";

const TEXTAREA_CLS =
  "min-h-[110px] p-3 text-sm text-gray-800 bg-white border border-gray-200 rounded-xl outline-none w-full resize-y focus:border-yellow-400 transition-colors focus:ring-2 focus:ring-yellow-100";

const RemarksForm = ({ readOnly }) => (
  <div className="oq-field-grid-2">
    <div>
      <FieldLabel>Inclusions</FieldLabel>
      <Field
        as="textarea"
        name="inclusions"
        placeholder="e.g. Ocean freight, THC at origin & destination…"
        className={TEXTAREA_CLS}
        disabled={readOnly}
      />
    </div>
    <div>
      <FieldLabel>Exclusions</FieldLabel>
      <Field
        as="textarea"
        name="exclusions"
        placeholder="e.g. Detention, demurrage, customs…"
        className={TEXTAREA_CLS}
        disabled={readOnly}
      />
    </div>
    <div style={{ gridColumn: "1 / -1" }}>
      <FieldLabel>Remarks</FieldLabel>
      <Field
        as="textarea"
        name="remarks"
        placeholder="Additional remarks for this rate…"
        className={`${TEXTAREA_CLS} min-h-[80px]`}
        disabled={readOnly}
      />
    </div>
  </div>
);

export default RemarksForm;
